/// <reference path="./compat.d.ts" />
import lightbox from "lightbox2";
import jQuery from "jquery";
import Masonry from "masonry-layout";
import jQueryBridget from "jquery-bridget";

if (window != null) {
  (window as any).jQuery = jQuery;
  (window as any).$ = jQuery;
  (window as any).lightbox = lightbox;

  jQueryBridget("masonry", Masonry, jQuery);
}
